import { FaInstagram } from 'react-icons/fa';
import imagyLogo from '../assets/imagy.png';
import '../css/Footer.css';

const INSTAGRAM_URL = 'https://www.instagram.com/imagy.agenda.turnos/';

function Footer() {
  return (
    <footer className="imagy-footer">
      <div className="imagy-footer__glow" aria-hidden="true" />

      <div className="imagy-footer__inner">
        <div className="imagy-footer__brand">
          <div className="imagy-footer__identity">
            <span className="imagy-footer__logo">
              <img
                src={imagyLogo}
                alt=""
              />
            </span>
            <div>
              <strong>IMAGY</strong>
              <span>Agenda inteligente</span>
            </div>
          </div>

          <p>
            Menos mensajes, más reservas. La agenda online que trabaja con vos
            para que puedas enfocarte en hacer crecer tu negocio.
          </p>
        </div>

        <a
          className="imagy-footer__instagram"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Seguir a Imagy en Instagram"
        >
          <span className="imagy-footer__instagram-icon">
            <FaInstagram aria-hidden="true" />
          </span>
          <span className="imagy-footer__instagram-copy">
            <small>Seguinos en Instagram</small>
            <strong>@imagy.agenda.turnos</strong>
            <span>Novedades, consejos y lanzamientos</span>
          </span>
          <span className="imagy-footer__instagram-arrow" aria-hidden="true">↗</span>
        </a>
      </div>

      <div className="imagy-footer__bottom">
        <span>© {new Date().getFullYear()} Imagy. Todos los derechos reservados.</span>
        <span>Un producto de <strong>IMAGINA Soluciones IT</strong></span>
      </div>
    </footer>
  );
}

export default Footer;
